import { useEffect, useState } from 'react';
import useFetchIam from '@/features/agent/api/useFetchIam';

export default function useTermsOfService() {
  const [shouldShowTermsDialog, setShouldShowTermsDialog] = useState(false);
  const { data: iam, isLoading } = useFetchIam();

  useEffect(() => {
    if (!isLoading && iam?.needs_to_accept_latest_terms === true) {
      setShouldShowTermsDialog(true);
    } else if (!isLoading && iam?.needs_to_accept_latest_terms === false) {
      setShouldShowTermsDialog(false);
    }
  }, [isLoading, iam?.needs_to_accept_latest_terms]);

  const closeTermsDialog = () => {
    setShouldShowTermsDialog(false);
  };

  return {
    shouldShowTermsDialog,
    closeTermsDialog,
    needsToAcceptTerms: iam?.needs_to_accept_latest_terms || false,
  };
}
